module.exports = __webpack_public_path__ + "img/SV.6413fcd6.png";